var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Calendar',{attrs:{"events":_vm.eventsFiltered,"holidays":_vm.holidays,"loading":_vm.loading},on:{"change":_vm.fetchData}},[_c('DivisionFilter',{model:{value:(_vm.filterDivision),callback:function ($$v) {_vm.filterDivision=$$v},expression:"filterDivision"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }